// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom scrollbar */
.custom-scrollbar::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
    background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
    background: rgba(99, 102, 241, 0.2);
    border-radius: 3px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: rgba(99, 102, 241, 0.4);
}

/* Floating animation */
@keyframes float {
    0%, 100% {
        transform: translate(0, 0) scale(1);
    }
    25% {
        transform: translate(var(--float-x, 20px), var(--float-y, -20px)) scale(1.05);
    }
    50% {
        transform: translate(calc(var(--float-x, 20px) * 0.5), calc(var(--float-y, -20px) * 1.5)) scale(0.95);
    }
    75% {
        transform: translate(calc(var(--float-x, 20px) * -0.5), var(--float-y, -20px)) scale(1.02);
    }
}

.animate-float {
    animation: float 6s ease-in-out infinite;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC;;AAEA,uBAAuB;AACvB;IACI;QACI,mCAAmC;IACvC;IACA;QACI,6EAA6E;IACjF;IACA;QACI,qGAAqG;IACzG;IACA;QACI,0FAA0F;IAC9F;AACJ;;AAEA;IACI,wCAAwC;AAC5C","sourcesContent":["/* Custom scrollbar */\n.custom-scrollbar::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n    background: rgba(99, 102, 241, 0.2);\n    border-radius: 3px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\n    background: rgba(99, 102, 241, 0.4);\n}\n\n/* Floating animation */\n@keyframes float {\n    0%, 100% {\n        transform: translate(0, 0) scale(1);\n    }\n    25% {\n        transform: translate(var(--float-x, 20px), var(--float-y, -20px)) scale(1.05);\n    }\n    50% {\n        transform: translate(calc(var(--float-x, 20px) * 0.5), calc(var(--float-y, -20px) * 1.5)) scale(0.95);\n    }\n    75% {\n        transform: translate(calc(var(--float-x, 20px) * -0.5), var(--float-y, -20px)) scale(1.02);\n    }\n}\n\n.animate-float {\n    animation: float 6s ease-in-out infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
